import React from "react";
import { Link } from "react-router-dom";
import { useLive } from "../LiveProvider";
import IconEdit from "../icons/IconEdit";
import IconClose from "../icons/IconClose";
import {
  Container,
  Grid,
  Cell,
  Prev,
  Next,
  EditContainer,
  Edit,
  Border
} from "./styled/live-footer";

function LiveFooter() {
  const { isDrawing, setIsDrawing, navigation } = useLive();

  return (
    <Container className="footer">
      <Grid>
        <Cell>
          {navigation.prevModule && (
            <Prev
              as={Link}
              to={navigation.prevModule.url}
              title={navigation.prevModule.footerTitle}
              className="footer-title footer-prev">
              {navigation.prevModule.icon}
              <span
                dangerouslySetInnerHTML={{
                  __html: navigation.prevModule.footerTitle
                }}
              />
            </Prev>
          )}
        </Cell>
        <Cell>
          <EditContainer>
            <Edit
              title="You can draw on the screen by clicking this button or using the p key on your keyboard."
              className="footer-telestrator"
              onClick={() => setIsDrawing((isDrawing) => !isDrawing)}>
              {isDrawing ? <IconClose /> : <IconEdit />}
            </Edit>
          </EditContainer>
        </Cell>
        <Cell>
          {navigation.nextModule && (
            <Next
              as={Link}
              to={navigation.nextModule.url}
              title={navigation.nextModule.footerTitle}
              className="footer-title footer-next">
              <span
                dangerouslySetInnerHTML={{
                  __html: navigation.nextModule.footerTitle
                }}
              />
              {navigation.nextModule.icon}
            </Next>
          )}
        </Cell>
      </Grid>
      <Border className="footer-border" />
    </Container>
  );
}

export default LiveFooter;
